import React from 'react';
import PendingCustomersComponent from './pending-customers.component';

export default function PendingCustomers() {
    return <PendingCustomersComponent />;
}
